import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appQuestionsDirectiveHost]',
})
export class QuestionsDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
